<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gKI2dD/tc-custom/9780819571021.jpg?1695285912995" alt="This image is the cover for the book Water for Hartford"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Water for Hartford
      </h1>
      <p class="bookDescription body article font2">
        <p><b>How three men brought clean water to Hartford, on a massive scale</b></p><p> As good health is inextricably wedded to pure drinking water—and this particular concern looms larger every day—understanding delivery systems is almost as important as the water itself.<i> Water for Hartford</i> chronicles the century-long effort, beginning in the 1850s, to construct a viable, efficient water system. The story of Hartford's water works is a fascinating one, for it recalls the hard work, great sacrifice, and extraordinary engineering feats necessary to deliver wholesome drinking water to a growing urban center. It also illuminates the ever-changing social, political, and economic milieu in which it was built. </p><p> The story of its construction is also the story of three men—Hiram Bissell, Ezra Clark, and Caleb Saville. Readers are transported back in time and given a firsthand glimpse of what these champions of a water system faced on a daily basis: unforgiving geography, venal politicians, and an often-indifferent public. The book culminates in the exhilaration of having built a water works from scratch to deliver clean, safe drinking water to the masses. Water for Hartford is a human story, peopled by men of vision and achievement, who understood that their decisions and actions would affect millions of people for decades to come. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Murphy
      </h2>
      
      <p class="authorDescription body article">KEVIN MURPHY is a writer whose interest in water systems dates back to fly-fishing trips in the West Branch Valley of the Farmington River&mdash;below the Metropolitan District Commission&#39;s Hogback Reservoir. A 1971 graduate of Villanova University, he worked at the Hartford Courant through the 1970s and then ran a successful building business until 2000. Today, he writes full time, but still manages to spend summer afternoons fly-fishing on the Farmington River in and around the tiny village of Riverton. He is also the author of <I>The Crowbar Governor</I> (2010).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wesleyan University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?149379e8